import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=2ec30745"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"
import style0 from "./NextSteps.vue?vue&type=style&index=0&id=2ec30745&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports